<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="false"></app-left-menu>
    <div id="main-container">
        <app-header [showHistoryButton]="true" [title]="title"></app-header>
        <div class="content-header"> </div>
        <div class="page-content settings">
            <div class="no-absolute m-t30">
                <span style="margin-bottom: 15px;display: block;color: red;">{{'Common.RequiredMessage'|
                    translate}}</span>
                <form [formGroup]="claimForm">
                    <label>{{'NewClaim.Label.PatientId' | translate}}<span class="required">*</span></label>
                    <input matInput #input placeholder="{{'Common.Placeholder.PatientId' | translate}}"
                        aria-label="State" class="form-control patientid" [matAutocomplete]="auto"
                        [formControl]="patient">
                    <mat-autocomplete (optionSelected)="onUserSelectionChanged($event)" [displayWith]="displayFn"
                        style="width: 280px;" #auto="matAutocomplete" class="autoComplete">
                        <mat-option *ngFor="let user of filteredUser | async" [value]="user">
                            <span *ngIf="user.UserId==0">
                                <span>{{user.FullName}}</span>
                            </span>
                            <span *ngIf="user.UserId>0">
                                <span>{{user.FullName}}</span> |
                                <small>{{user.UserId}}</small>
                            </span>
                        </mat-option>
                    </mat-autocomplete>
                    <div class="no-absolute" *ngIf="(authorization?.length>0)">
                        <!-- <div class="history"><strong>Member Name </strong>: {{fullName}}</div> -->
                        <div class="history"><strong>{{'Common.Authorization.Details'|translate}}</strong></div>
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>{{'Common.FromDate' | translate}}</th>
                                    <th>{{'Common.ToDate'| translate}}</th>
                                    <th>{{'Common.SessionAllowed'| translate}}</th>


                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let item of authorization">
                                    <td>{{item.FromDate | date:'MM/dd/yyyy'}}</td>
                                    <td>{{item.ToDate | date:'MM/dd/yyyy'}}</td>
                                    <td>
                                        {{item.SessionAuthorized}}
                                    </td>

                                </tr>
                                <tr *ngIf="!(authorization?.length>0)">
                                    <td colspan="4">{{'NewClaim.Message.AuthorizationNotFound' | translate}} </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="no-absolute" *ngIf="(dateOfService?.length>0)">
                        <!-- <div class="history"><strong>Member Name </strong>: {{fullName}}</div> -->
                        <div class="history"><strong>{{'Common.DateOfService'|translate}}</strong></div>
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>{{'Common.Approved' | translate}}</th>
                                    <th>{{'Common.Denied'| translate}}</th>
                                    <th>{{'Common.Submitted'| translate}}</th>


                                </tr>
                            </thead>
                            <tbody>

                                <tr>
                                    <td style="width:33%;overflow-wrap:anywhere">
                                        <div>{{approved}}</div>
                                    </td>
                                    <td style="width:33%;overflow-wrap:anywhere">
                                        <div>{{denied}}</div>
                                    </td>
                                    <td style="width:33%;overflow-wrap:anywhere">
                                        <div> {{submitted}}</div>
                                    </td>


                                </tr>
                                <tr *ngIf="!(dateOfService?.length>0)">
                                    <td colspan="4">{{'NewClaim.Message.DateOfServiceNotFound' | translate}} </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <label>{{'NewClaim.Label.DateOfService' | translate}}<span class="required">*</span></label>
                    <div id="divDateOfService" style="cursor: pointer;" class="patientid">
                        <span class="placeholder"> {{'NewClaim.Label.DateOfService' | translate}}
                        </span>
                    </div>
                    <input type="text" class="date dateOfService" formControlName="DateOfService">



                    <label>{{'NewClaim.Label.TypeOfService' | translate}}<span class="required">*</span></label>
                    <select formControlName="TypeOfService">
                        <option value="">{{"Common.Select"|translate}}</option>
                        <option value="{{item.Id}}" *ngFor="let item of typeOfService">
                            {{item.Name | uppercase }}
                        </option>
                    </select>

                    <label>{{'NewClaim.Label.PrimaryDiagnosis' | translate}}</label>

                    <input type="text" placeholder="{{'Common.Placeholder.DiagnosisCode' | translate}}"
                        formControlName="PrimaryDiagnoses">

                    <label>{{'Is another session scheduled?' | translate}}<span class="required">*</span></label>
                    <br />
                    <input type="radio" (click)="onsessionscheduled('1')" id="sessionscheduled1"
                        [checked]="yesRadioButtonCheckd==true" name="IsAnotherSessionScheduled"
                        formControlName="IsAnotherSessionScheduled" value="1">
                    <label for="sessionscheduled1">Yes</label>
                    <input type="radio" (click)="onsessionscheduled('0')" id="sessionscheduled2"
                        [checked]="noRadioButtonCheckd==true" name="IsAnotherSessionScheduled"
                        formControlName="IsAnotherSessionScheduled" value="0">
                    <label for="sessionscheduled2">No</label><br>



                    <label *ngIf="isSessionScheduled==1">{{'What is the date of next session?' | translate}}<span
                            class="required">*</span></label>
                    <div *ngIf="isSessionScheduled==1" id="divDateOfService1" style="cursor: pointer;"
                        class="patientid1">

                    </div>
                    <div *ngIf="isSessionScheduled==1" style="display:inline-flex;width:100%;">
                        <input type="text" readonly='true' class="date1 dateOfService1"
                            formControlName="DateOfNextSession" style="width:95%!important;">
                        <div class="divCalenderPlaceHolder"></div>
                    </div>
                    <label *ngIf="isSessionScheduled==1">{{'What is the outcome (or anticipated outcome) of this case?'
                        | translate}}<span class="required">*</span></label>

                    <select *ngIf="isSessionScheduled==1" formControlName="AnticipatedOutcomeOfThisCase">
                        <option value="">{{"Common.Select"|translate}}</option>
                        <option value="{{item.Id}}" *ngFor="let item of anticpatedOutcome">
                            {{item.Name}}
                        </option>
                    </select>

                    <label *ngIf="isSessionScheduled==0">{{'NewClaim.Label.ReasonEapserviceEnded' | translate}}<span
                            class="required">*</span></label>
                    <select *ngIf="isSessionScheduled==0" formControlName="ReasonEapserviceEnded">
                        <option value="">{{"Common.Select"|translate}}</option>
                        <option value="{{item.Id}}" *ngFor="let item of eapReasonEnded">
                            {{item.Name}}
                        </option>
                    </select>

                    <label>{{'NewClaim.Label.Notes' | translate}}<span *ngIf="applyValidation"
                            class="required">*</span></label>
                    <div *ngIf="noteDesclaimer"
                        style="padding-left:5px;display:inline-block;color: red;text-align: center;">{{noteDesclaimer}}
                    </div>
                    <textarea placeholder="{{ 'Common.Placeholder.Notes' | translate}}" appCharCount [limit]=500
                        [showinitial]="true" formControlName="Notes" style="padding:0px 10px 0px"></textarea>
                    <span id="char-count" class="char-count"></span>

                    <div *ngIf="isSessionScheduled==2">
                        <span class="error-message" *ngIf="error"> {{error}}</span>
                        <div>
                            <div class="col-md-6" *ngIf="claimId<=0">
                                <input type="submit" id="login" [disabled]="true" class="btn btn-main"
                                    value="{{ 'NewClaim.Buttons.SaveContinue' | translate}}" />
                            </div>
                            <div [class.col-md-6]="claimId<=0">
                                <input type="submit" id="login" [disabled]="true" class="btn btn-main"
                                    value="{{(claimId>0?'Common.Save':'NewClaim.Buttons.SaveExit') | translate}}" />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isSessionScheduled!=2">
                        <span class="error-message" *ngIf="error"> {{error}}</span>
                        <div>
                            <div class="col-md-6" *ngIf="claimId<=0">
                                <input type="submit" (click)="addClaim(claimForm.value,false)" id="login"
                                    [disabled]="!claimForm.valid" class="btn btn-main"
                                    value="{{ 'NewClaim.Buttons.SaveContinue' | translate}}" />
                            </div>
                            <div [class.col-md-6]="claimId<=0">
                                <input type="submit" id="login" (click)="addClaim(claimForm.value,true)"
                                    [disabled]="!claimForm.valid" class="btn btn-main"
                                    value="{{(claimId>0?'Common.Save':'NewClaim.Buttons.SaveExit') | translate}}" />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>